import {
  Component,
  Input,
  Output,
  EventEmitter,
  AfterViewInit, OnChanges, SimpleChanges,
} from '@angular/core';
import { MyAlertProvider } from "../../providers/my-alert/my-alert";

/**
 * Generated class for the AddKeywordComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'add-keyword',
  templateUrl: 'add-keyword.html',
  host: { '(document:click)': 'cancelChoosed($event)' },
})
export class AddKeywordComponent implements AfterViewInit ,OnChanges{
  text: string;

  @Input() keyword_list;
  @Input() at_switch;
  @Output() atSwitch = new EventEmitter();
  @Output() changeHeight = new EventEmitter();
  @Input() max_count;

  //模糊匹配的开关
  vagueToggle: boolean = true;

  new_keyword;
  constructor(public myAlert: MyAlertProvider
  ) {
    console.log('Hello AddKeywordComponent Component');
    this.text = 'Hello World';
  }

  ngAfterViewInit() {
    this.changeHeight.emit(true);
  }

  // 初始化模糊匹配开关
  ngOnChanges(changes:SimpleChanges){
    if(this.keyword_list && changes['keyword_list'] && this.keyword_list.length){
      this.vagueToggle = !this.keyword_list[0].is_full_match;
    }
  }

  enterAddKeyWord(e) {
    if (e.keyCode == 13 && this.new_keyword != '') {
      this.addKeyWord();
    }
  }

  addKeyWord() {
    if (this.new_keyword && this.new_keyword != '') {
      if (
        this.keyword_list.every(
          item => item.keyword_content != this.new_keyword
        )
      ) {
        this.keyword_list.push({
          keyword_content: this.new_keyword,
          is_full_match: !this.vagueToggle,
        });
      }
      this.new_keyword = '';
      this.changeHeight.emit(true);
    }else{


      let alertObj = {
        type: 'warning',
        title: '请设置关键词',
        message:  '自动回复关键词不能为空！',
        success: {
          text: '知道了',
        },
      };
      this.myAlert.showAlert(alertObj);
    }
  }

  choosed_tag;
  deleteTag(e, index) {
    e.stopPropagation();
    // if(this.choosed_tag && this.choosed_tag.keyword_content == tag.keyword_content ){
    this.keyword_list.splice(index, 1);
    this.changeHeight.emit(true);

    // }
    // else {
    //   this.choosed_tag = tag;
    // }
  }

  cancelChoosed(e) {
    this.choosed_tag = null;
  }

  /**
   * 开关 模糊匹配开关*/
  switch(){
    this.vagueToggle = !this.vagueToggle;
    this.keyword_list.forEach(value =>{
      value.is_full_match = !this.vagueToggle;
    });
  }

  switch2(){
    this.at_switch = Math.abs(this.at_switch - 1);
    this.atSwitch.emit(this.at_switch)
  }
  // formatKeywordList(){
  //   return this.keyword_list?Array.from(this.keyword_list):[];
  // }
}



// WEBPACK FOOTER //
// ./src/components/add-keyword/add-keyword.ts